import { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { CheckCircle, Eye, EyeSlash, XCircle } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Validation from "../../../../hooks/Validation";
import { changePassword } from "../../../../store/actions/adminAction";
import { adminReset } from "../../../../store/reducerSlice/admin";
import Loader from "../../../common/loader/Loader";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";

const formElements = [
  {
    key: "oldPassword",
    label: "Current Password",
    placeHolder: "Enter current password",
    type: "password",
  },
  {
    key: "newPassword",
    label: "New Password",
    placeHolder: "Enter new password",
    type: "password",
  },
  {
    key: "confirmPassword",
    label: "Confirm Password",
    placeHolder: "Confirm new password",
    type: "password",
  },
];

const ResetPasswordForm = () => {
  const [passwordDetail, setPasswordDetail] = useState({
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
  });
  const [eyes, setEyes] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [isShow, setIsShow] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation(passwordDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    adminDetail,
    isLoader,
    isRecordUpdated,
    error: apiError,
  } = useSelector((state) => state.admin);

  const submitHandler = (e) => {

    e.preventDefault();
    if (!isError() && error !== null) {

      const { confirmPassword, newPassword, oldPassword, ...rest } =
        passwordDetail;
      dispatch(
        changePassword({
          adminId: adminDetail.adminId,
          ...rest,
          newPassword: newPassword,
          oldPassword: oldPassword,
          confirmPassword:confirmPassword,
        })
      ).then((payload) => {
        setIsShow(true);

        if (payload?.payload?.success) {
          setSuccessMessage(payload?.payload?.message);
          setIsDone(true);
          setPasswordDetail({
            oldPassword: null,
            newPassword: null,
            confirmPassword: null,
          });
        }
      });
      setIsActionCalled(false);
    }
  };

  const hideHandlerRes = () => {
    if (isDone) {
      dispatch(adminReset());
      navigate("/");
    }
    setIsShow(false);
  };

  useEffect(() => {
    return () => {
      dispatch(adminReset());
    };
  }, []);

  return (
    <>
      <Form
        onSubmit={(e) => submitHandler(e)}
        style={{ maxWidth: 600, margin: "0 auto" }}
        noValidate
      >
        {/* <h1 className={Styles.h1}>Login</h1> */}
        {isLoader && <Loader />}

        {formElements.map((element, i) => {
          return (
            <Form.Group
              className="mb-4 rowField"
              controlId="formBasicEmail"
              key={i}
            >
              <Form.Label>
                {element.label} <span className="required">*</span>
              </Form.Label>
              <Form.Control
                type={eyes[element.key] ? "text" : element.type}
                name={element.key}
                placeholder={element.placeHolder}
                value={passwordDetail && passwordDetail[element.key]}
                onChange={(e) => {
                  setPasswordDetail({
                    ...passwordDetail,
                    [element.key]:  e.target.value,
                  });
                  // resetValidator(e.target.name);
                  // checkValidator(element.key)
                }}
                onKeyUp={(e) => {
                  //(passwordDetail && passwordDetail[element.key] && element.key === 'newPassword') &&
                  if(element.key==='newPassword'&& passwordDetail?.confirmPassword!=null){
                    checkValidator()
                   }
                   else{
                    checkValidator(element.key)
                   }
                }}
                isInvalid={
                  error &&
                  error !== null &&
                  typeof error[element.key] !== "object" &&
                  error[element.key]
                }
              />
              <div
                className="eyeIcon"
                onClick={(e) =>
                  setEyes({
                    ...eyes,
                    [element.key]: !eyes[element.key],
                  })
                }
              >
                {eyes[element.key] ? <Eye /> : <EyeSlash />}
              </div>
              <Form.Control.Feedback type="invalid">
                {error &&
                  error !== null &&
                  typeof error[element.key] !== "object" &&
                  error[element.key]}
              </Form.Control.Feedback>
              {element.key === "newPassword" && (
                <Form.Text
                  className={`passwordRules ${
                    error && passwordDetail[element.key] && "valid"
                  }`}
                >
                  <h3>Your password must have:</h3>
                  <p
                    className={
                      passwordDetail[element.key]
                        ? error &&
                          error?.newPassword?.lowercase &&
                          error[element.key]?.lowercase
                          ? "invalid"
                          : ""
                        : ""
                    }
                  >
                    {!passwordDetail?.newPassword ? (
                      <XCircle />
                    ) : error?.newPassword?.lowercase ? (
                      <XCircle />
                    ) : (
                      <CheckCircle />
                    )}{" "}
                    At least one lowercase letter
                  </p>
                  <p
                    className={
                      passwordDetail[element.key]
                        ? error &&
                          error?.newPassword?.uppercase &&
                          error[element.key]?.uppercase
                          ? "invalid"
                          : ""
                        : ""
                    }
                  >
                    {!passwordDetail?.newPassword ? (
                      <XCircle />
                    ) : error?.newPassword?.uppercase ? (
                      <XCircle />
                    ) : (
                      <CheckCircle />
                    )}{" "}
                    At least one UPPERCASE letter
                  </p>
                  <p
                    className={
                      passwordDetail[element.key]
                        ? error &&
                          error?.newPassword?.number &&
                          error[element.key]?.number
                          ? "invalid"
                          : ""
                        : ""
                    }
                  >
                    {!passwordDetail?.newPassword ? (
                      <XCircle />
                    ) : error?.newPassword?.number ? (
                      <XCircle />
                    ) : (
                      <CheckCircle />
                    )}{" "}
                    At least one number
                  </p>
                  <p
                    className={
                      passwordDetail[element.key]
                        ? error &&
                          error?.newPassword?.special &&
                          error[element.key]?.special
                          ? "invalid"
                          : ""
                        : ""
                    }
                  >
                    {!passwordDetail?.newPassword ? (
                      <XCircle />
                    ) : error?.newPassword?.special ? (
                      <XCircle />
                    ) : (
                      <CheckCircle />
                    )}{" "}
                    At least one special character
                  </p>
                  <p
                    className={
                      passwordDetail[element.key]
                        ? error &&
                          error?.newPassword?.length &&
                          error[element.key]?.length
                          ? "invalid"
                          : ""
                        : ""
                    }
                  >
                    {!passwordDetail?.newPassword ? (
                      <XCircle />
                    ) : error?.newPassword?.length ? (
                      <XCircle />
                    ) : (
                      <CheckCircle />
                    )}{" "}
                    At least 8 characters
                  </p>
                </Form.Text>
              )}
            </Form.Group>
          );
        })}
        <div className="requiredNote">
          Note: You must complete all the mandatory fields.
        </div>
        <br />
        <Button className="btn-primary" type="submit">
          Update
        </Button>
      </Form>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded: isShow,
          title: "Reset Password",
          successMsg: successMessage,
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default ResetPasswordForm;
